import { createContext, useContext } from "react";

/**
 * Lets `AuthProvider` be told that a request was rejected for want of a valid
 * session, even though the API client is created above it.
 *
 * The client is constructed in `App` (it is needed to fetch capabilities, which
 * the auth shell itself branches on), so it cannot close over auth state that
 * does not exist yet. Rather than reach for a module-level global — untestable,
 * and shared between the several app instances the workflow tests mount in one
 * process — `App` owns a mutable slot and hands it down; `AuthProvider` fills it
 * in on mount.
 */
export interface SessionExpiryChannel {
  /** Set by `AuthProvider`. Absent until it mounts, which is why the client calls it optionally. */
  onExpired: (() => void) | null;
}

export const SessionExpiryContext = createContext<SessionExpiryChannel | null>(null);

export function useSessionExpiryChannel(): SessionExpiryChannel | null {
  return useContext(SessionExpiryContext);
}
